import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useCardClick = () =>
	useSendEvent<{
		index: number;
		bot_UserId: number;
	}>(events.grid.cardClick, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useGridViewed = ({ page }: { page?: number }) =>
	useSendEvent(
		events.grid.viewGrid,
		page
			? {
					page_number: page,
			  }
			: undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

export const useGridFiltersSubmitted = () =>
	useSendEvent<{
		text_filtered: string;
		filters_manual: 0 | 1;
		safe: 'SFW' | 'NSFW';
		age: string;
		gender?: string;
		createdBy?: string;
		desires?: string;
		sorting_bot_grid?: string[];
	}>(events.grid.filterSubmitted, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
